/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeetingNoteRequest
 */
export interface MeetingNoteRequest {
    /**
     * User Id
     * @type {string}
     * @memberof MeetingNoteRequest
     */
    userId?: string;
    /**
     * Full text of the meeting note
     * @type {string}
     * @memberof MeetingNoteRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the MeetingNoteRequest interface.
 */
export function instanceOfMeetingNoteRequest(value: object): boolean {
    return true;
}

export function MeetingNoteRequestFromJSON(json: any): MeetingNoteRequest {
    return MeetingNoteRequestFromJSONTyped(json, false);
}

export function MeetingNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeetingNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function MeetingNoteRequestToJSON(value?: MeetingNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'note': value['note'],
    };
}

